import { getItem, removeItem } from './cache';
import { LOCAL_STORAGE_CONSTANT, PAYMENT_INTERVAL } from '../constants/app';
import {
  doFetchProductsRequest,
  doPaymentInitiationRequest,
} from '../store/action/products';
import { APP_ROUTES } from '../route';
import { encodeBase64Value } from './url';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../services/Notification';

export const PRODUCT_TO_INTERVAL = {
  'jen-monthly': PAYMENT_INTERVAL.MONTHLY,
  'jen-annual': PAYMENT_INTERVAL.YEARLY,
};

export const isJoinDeepLinkPurchaseIntent = () =>
  Boolean(
    getItem(LOCAL_STORAGE_CONSTANT.JOIN_DEEP_LINK_FLOW) ||
      getItem('deepLinkProduct'),
  );

export const clearJoinDeepLinkFlowFlag = () => {
  removeItem(LOCAL_STORAGE_CONSTANT.JOIN_DEEP_LINK_FLOW);
};

export const clearJoinDeepLinkMembershipKeys = () => {
  clearJoinDeepLinkFlowFlag();
  removeItem('deepLinkProduct');
};

const getOrderErrors = error => {
  const errors =
    error?.response?.data?.response?.errors ||
    error?.response?.data?.errors ||
    error?.response?.data?.error;

  if (Array.isArray(errors)) return errors.flat();
  return errors ? [errors] : [];
};

const isActiveSubscriptionError = error =>
  getOrderErrors(error).some(message =>
    String(message).toLowerCase().includes('active subscription'),
  );

const redirectAfterActiveSubscription = navigate => {
  clearJoinDeepLinkMembershipKeys();
  createNotification({
    type: NOTIFICATION_TYPE.ERROR,
    message: 'An active subscription is present already.',
  });
  if (navigate) {
    navigate(APP_ROUTES.HOME, { replace: true });
  } else {
    window.location.assign(APP_ROUTES.HOME);
  }
};

export const initiateJoinDeepLinkMembershipCheckout = (
  dispatch,
  navigate,
  product,
) => {
  const deepLinkProduct = product || getItem('deepLinkProduct');
  if (!deepLinkProduct) return false;

  const interval = PRODUCT_TO_INTERVAL[deepLinkProduct];
  if (!interval) return false;

  clearJoinDeepLinkMembershipKeys();
  dispatch(
    doFetchProductsRequest({
      interval,
      callback: () => {
        dispatch(
          doPaymentInitiationRequest({
            page: encodeBase64Value(APP_ROUTES.FREE_TRAIL),
            interval,
            errorCallBack: error => {
              if (isActiveSubscriptionError(error)) {
                redirectAfterActiveSubscription(navigate);
                return true;
              }
              return false;
            },
          }),
        );
      },
    }),
  );
  return true;
};
